// const QUACK = 'app/duck/QUACK';
const OPEN_CASH_OUT_MODAL = 'supportersScreen/OPEN_CASH_OUT_MODAL';
const CLOSE_CASH_OUT_MODAL = 'supportersScreen/CLOSE_CASH_OUT_MODAL';

const OPEN_SUPPORT_DETAILS_MODAL =
  'supportersScreen/OPEN_SUPPORT_DETAILS_MODAL';
const CLOSE_SUPPORT_DETAILS_MODAL =
  'supportersScreen/CLOSE_SUPPORT_DETAILS_MODAL';

const FETCH_CAMPAIGNS_START = 'supportersScreen/FETCH_CAMPAIGNS_START';
const FETCH_CAMPAIGNS_SUCCESS = 'supportersScreen/FETCH_CAMPAIGNS_SUCCESS';
const FETCH_CAMPAIGNS_FAILURE = 'supportersScreen/FETCH_CAMPAIGNS_FAILURE';

const SET_CAMPAIGNS = 'supportersScreen/SET_CAMPAIGNS';

const SET_IS_SHOWING_HOW_SPONSORSHIPS_WORKS_MODAL =
  'supportersScreen/SET_IS_SHOWING_HOW_SPONSORSHIPS_WORKS_MODAL';

export default {
  OPEN_CASH_OUT_MODAL,
  CLOSE_CASH_OUT_MODAL,
  OPEN_SUPPORT_DETAILS_MODAL,
  CLOSE_SUPPORT_DETAILS_MODAL,
  FETCH_CAMPAIGNS_START,
  FETCH_CAMPAIGNS_SUCCESS,
  FETCH_CAMPAIGNS_FAILURE,
  SET_CAMPAIGNS,
  SET_IS_SHOWING_HOW_SPONSORSHIPS_WORKS_MODAL,
};
